/**
 * Resolve the company root team id ("teamHeight") from a teams map or array.
 *
 * Rules (shared across insights / dashboard / report / questions):
 * 1. Collect teams with empty/missing `parent` (top-level).
 * 2. If exactly one → that is the root.
 * 3. If several → prefer the one that actually has children.
 * 4. Otherwise fall back to the first top-level id.
 */
export function resolveTeamHeightFromTeams(teamsData: any): string | null {
  if (!teamsData) {
    return null
  }

  const teamAll: Array<{ key: string; parent?: any }> = []
  const topmostArr: string[] = []

  if (Array.isArray(teamsData)) {
    for (const team of teamsData) {
      if (!team || typeof team !== 'object') continue
      const key = String(team.key || team.id || '').trim()
      if (!key) continue
      const teamObj = Object.assign({}, team, { key })
      teamAll.push(teamObj)
      if (!teamObj.parent) {
        topmostArr.push(key)
      }
    }
  } else if (typeof teamsData === 'object') {
    for (const key of Object.keys(teamsData)) {
      const team = teamsData[key]
      if (!team || typeof team !== 'object') continue
      const teamObj = Object.assign({}, team, { key: team.key || key })
      teamAll.push(teamObj)
      if (!teamObj.parent) {
        topmostArr.push(String(teamObj.key))
      }
    }
  } else {
    return null
  }

  if (topmostArr.length === 0) {
    return null
  }

  if (topmostArr.length === 1) {
    return topmostArr[0]
  }

  const withChildren = topmostArr.find((value) =>
    teamAll.some((team) => team.parent === value)
  )

  return withChildren || topmostArr[0]
}
